module.exports = __webpack_public_path__ + "static/media/Fr-Abraham.df646571.png";